import { createStyles } from '@material-ui/core'
import makeStylesWrapper from 'core/helpers/styles'

const style = () =>
  createStyles({
    root: {},
  })

export default makeStylesWrapper(style)
